<template>
  <div class="login-page">
    <img class="login-bg" src="/img/login/login_back.png" />
    <div class="login-template">
      <div class="login-content">
        <div class="login-info">
          <img src="/img/logo/login_logo.png" />
          <div class="login-info-main-text">{{$t("Login1")}}</div>
          <div class="login-info-sub-text">
            <div>{{$t("Login2")}}</div>
            <div>{{$t("Login3")}}</div>
          </div>
        </div>
        <div class="login-form">
          <div class="input-area">
            <input
              class="login-input"
              type="text"
              v-model="userEmail"
              @input="onChangeInput"
              @keypress.enter="onLogin"
              :placeholder="$t('TP_Edit_2_Reservation_list3')"
            />
          </div>
          <div class="input-area">
            <input
              class="login-input"
              :type="showPassword ? 'text' : 'password'"
              v-model="userPasswd"
              @input="onChangeInput"
              @keypress.enter="onLogin"
              :placeholder="$t('User_Add3')"
            />
            <button class="lock-icon" @click="onShowPassword">
              <img v-if="showPassword" src="/img/common/pass_on.png" alt="pass_on" />
              <img v-else src="/img/common/pass_off.png" alt="pass_off" />
            </button>
          </div>

          <a-checkbox
            class="login-checkbox"
            :checked="Boolean(saveCheck)"
            @change="onChangeCheck"
          >{{$t("Login4")}}</a-checkbox>

          <div
            v-if="loginState.loginResult > 1 && loginState.loginMessage"
            class="error-message"
          >{{loginState.loginMessage}}</div>

          <button class="btn-login" @click="onLogin()">{{$t("Login5")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, toRefs, computed, onBeforeMount, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
import { apiUrl, nowEpoch } from "@/utils/common";


export default {
  name: "Login",
  setup() {
    const store = useStore();
    const loginState = computed(() => store.getters["login/STATE"]);
    const router = useRouter();

    const state = reactive({
      saveEmail: localStorage.getItem("saveEmail") || "",
      saveCheck: Boolean(Number(localStorage.getItem("saveCheck")) || 0),
      userEmail: localStorage.getItem("saveEmail") || "",
      userPasswd: "",
      loading: false,
      showPassword: false,
    });

    const onChangeInput = () => {
      if (loginState.value.loginResult > 1) {
        store.dispatch("login/CHANGE_STATE", { loginResult: 0 });
      }
    };

    const onChangeCheck = () => {
      state.saveCheck = Number(!state.saveCheck);
    };

    const onShowPassword = () => {
      state.showPassword = !state.showPassword;
    };

    const onLogin = async () => {
      state.loading = true;

      const params = {
        userEmail: state.userEmail.toLowerCase(),
        userPasswd: state.userPasswd,
      };

      // 이메일 저장 체크시 쿠키에 이메일 저장
      if (state.saveCheck) {
        localStorage.setItem("saveCheck", 1);
        localStorage.setItem("saveEmail", state.userEmail);
      } else {
        localStorage.setItem("saveCheck", 0);
        localStorage.setItem("saveEmail", "");
      }

      try {
        const response = await axios.post(apiUrl + "Login", params);
        if (response && !response.data.error) {
          store.dispatch("login/POST_LOGIN", response);
          router.push("/template");

          const { loginResult, userData, sessionTimeout } = response.data.list;
          if (loginResult === 1) {
            // userData['serviceNo'] = serviceNo;
            // await UserActions.setUser({ user: userData, sessionTimeout });
            sessionStorage.setItem("curUser", userData.userEmail);
            sessionStorage.setItem("accessTime", nowEpoch());
            localStorage.removeItem("loginAdmin");
            localStorage.setItem("loginUser", userData.userEmail);

            // 로그인 횟수 초기화
            localStorage.setItem("loginCnt", 0);

            // 언어 설정
            if (
              localStorage.getItem("language") !== userData.lang &&
              userData.lang
            ) {
              localStorage.setItem("language", userData.lang);
            }
          } else if (loginResult === 2) {
            // 로그인 서버 에러
          } else if (loginResult === 4) {
            // ID or 비밀번호 불일치
          } else if (loginResult === 8) {
            // 비밀번호 5회 이상 실패
          } else if (loginResult === 16) {
            // 6개월 이상 비밀번호 미변경
            // return window.location.replace('/login/passwdReset');
          } else if (loginResult === 32) {
            // 비활성화 계정 - 로그인가능
            // sessionStorage.setItem('curUser', userData.userEmail);
            // LoginActions.viewNoActive(true);
            // localStorage.removeItem('loginAdmin');
            // localStorage.setItem('loginUser', userData.userEmail);
            // sessionStorage.setItem('accessTime', common.nowEpoch());
          } else if (loginResult === 64) {
            // 비활성화 계정 - 기간 만료
            // LoginActions.viewNoActive(true);
          } else if (loginResult === 128) {
            // 잠김 계정
          } else if (loginResult === 256) {
            // 관리자가 생성한 계정 최초 로그인시 비밀번호 수정 화면
            // this.setState({ isFirstLogin: true });
          }
        }
      } catch (error) {
        store.dispatch("login/POST_LOGIN", error);
      }

      state.loading = false;
    };

    return {
      ...toRefs(state),
      // userEmail,
      // userPasswd,
      loginState,
      onChangeInput,
      onChangeCheck,
      onLogin,
      // saveCheck,
      // loading,
      // showPassword,
      onShowPassword,
    };
  },
};
</script>